const HALF_WIDTH_TO_FULL_WIDTH = {
  ｦ: 'ヲ',
  ｧ: 'ァ',
  ｨ: 'ィ',
  ｩ: 'ゥ',
  ｪ: 'ェ',
  ｫ: 'ォ',
  ｬ: 'ャ',
  ｭ: 'ュ',
  ｮ: 'ョ',
  ｯ: 'ッ',
  ｰ: 'ー',
  ｱ: 'ア',
  ｲ: 'イ',
  ｳ: 'ウ',
  ｴ: 'エ',
  ｵ: 'オ',
  ｶ: 'カ',
  ｷ: 'キ',
  ｸ: 'ク',
  ｹ: 'ケ',
  ｺ: 'コ',
  ｻ: 'サ',
  ｼ: 'シ',
  ｽ: 'ス',
  ｾ: 'セ',
  ｿ: 'ソ',
  ﾀ: 'タ',
  ﾁ: 'チ',
  ﾂ: 'ツ',
  ﾃ: 'テ',
  ﾄ: 'ト',
  ﾅ: 'ナ',
  ﾆ: 'ニ',
  ﾇ: 'ヌ',
  ﾈ: 'ネ',
  ﾉ: 'ノ',
  ﾊ: 'ハ',
  ﾋ: 'ヒ',
  ﾌ: 'フ',
  ﾍ: 'ヘ',
  ﾎ: 'ホ',
  ﾏ: 'マ',
  ﾐ: 'ミ',
  ﾑ: 'ム',
  ﾒ: 'メ',
  ﾓ: 'モ',
  ﾔ: 'ヤ',
  ﾕ: 'ユ',
  ﾖ: 'ヨ',
  ﾗ: 'ラ',
  ﾘ: 'リ',
  ﾙ: 'ル',
  ﾚ: 'レ',
  ﾛ: 'ロ',
  ﾜ: 'ワ',
  ﾝ: 'ン',
  ' ': '　',
  '¢': '￠',
  '£': '￡',
  '¬': '￢',
  '¯': '￣',
  '¦': '￤',
  '¥': '￥',
  '₩': '￦',
  '⦆': '｠',
  '⦅': '｟'
};
const FULL_WIDTH_TO_HALF_WIDTH = Object.entries(HALF_WIDTH_TO_FULL_WIDTH).reduce((acc, curr) => {
  acc[curr[1]] = curr[0];
  return acc;
}, {});

// Voiced (dakuten) and semi-voiced (handakuten) katakana mappings: full-width → half-width
// Half-width voiced/semi-voiced katakana are composed of two characters: base + sound mark (ﾞ or ﾟ)
const VOICED_KATAKANA_TO_HALF_WIDTH = {
  // Voiced katakana (dakuten - ﾞ)
  ガ: 'ｶﾞ',
  ギ: 'ｷﾞ',
  グ: 'ｸﾞ',
  ゲ: 'ｹﾞ',
  ゴ: 'ｺﾞ',
  ザ: 'ｻﾞ',
  ジ: 'ｼﾞ',
  ズ: 'ｽﾞ',
  ゼ: 'ｾﾞ',
  ゾ: 'ｿﾞ',
  ダ: 'ﾀﾞ',
  ヂ: 'ﾁﾞ',
  ヅ: 'ﾂﾞ',
  デ: 'ﾃﾞ',
  ド: 'ﾄﾞ',
  バ: 'ﾊﾞ',
  ビ: 'ﾋﾞ',
  ブ: 'ﾌﾞ',
  ベ: 'ﾍﾞ',
  ボ: 'ﾎﾞ',
  ヴ: 'ｳﾞ',
  // Semi-voiced katakana (handakuten - ﾟ)
  パ: 'ﾊﾟ',
  ピ: 'ﾋﾟ',
  プ: 'ﾌﾟ',
  ペ: 'ﾍﾟ',
  ポ: 'ﾎﾟ'
};

// Build reverse mapping for half-width → full-width conversion
const HALF_WIDTH_TO_VOICED_KATAKANA = Object.entries(VOICED_KATAKANA_TO_HALF_WIDTH).reduce((acc, [fullWidth, halfWidth]) => {
  acc[halfWidth] = fullWidth;
  return acc;
}, {});
function convertJapaneseSpecificCharsToFullWidth(text) {
  // Convert half-width voiced/semi-voiced katakana (two chars) to full-width (one char)
  let result = text;
  for (const [halfWidth, fullWidth] of Object.entries(HALF_WIDTH_TO_VOICED_KATAKANA)) {
    result = result.replace(new RegExp(halfWidth, 'g'), fullWidth);
  }
  return result;
}
function convertJapaneseSpecificCharsToHalfWidth(text) {
  // Convert full-width voiced/semi-voiced katakana (one char) to half-width (two chars)
  let result = text;
  for (const [fullWidth, halfWidth] of Object.entries(VOICED_KATAKANA_TO_HALF_WIDTH)) {
    result = result.replace(new RegExp(fullWidth, 'g'), halfWidth);
  }
  return result;
}
export function convertToFullWidth(text) {
  return [...toFullWidthAscii(text)].map(c => HALF_WIDTH_TO_FULL_WIDTH[c] || c).join('');
}

// Converts the fullwidth characters in the "Halfwidth and Fullwidth Forms" Unicode block to their halfwidth versions
export function convertFromFullwidth(text) {
  return [...toHalfWidthAscii(text)].map(c => FULL_WIDTH_TO_HALF_WIDTH[c] || c).join('');
}
function shiftCharCode(delta) {
  return c => String.fromCodePoint(c.codePointAt(0) + delta);
}
function toHalfWidthAscii(str) {
  // Match all characters between '！' and '～' corresponding to unicode 0xFF01 and 0xFF5E
  // Apply a shift to convert to half width form corresponding to ranges 0x0021 - 0x007E
  // the shift amount is the difference between 0x0021 and 0xFF01 = -0xFEE0
  return convertJapaneseSpecificCharsToHalfWidth(str).replace(/[！-～]/g, shiftCharCode('!'.codePointAt(0) - '！'.codePointAt(0)));
}
function toFullWidthAscii(str) {
  // Match all characters between '!' and '~' corresponding to unicode 0x0021 and 0x007E
  // Apply a shift to convert to full width form corresponding to ranges 0xFF01 - 0xFF5E
  // the shift amount is the difference between 0xFF01 and 0x0021 = 0xFEE0
  return convertJapaneseSpecificCharsToFullWidth(str).replace(/[!-~]/g, shiftCharCode('！'.codePointAt(0) - '!'.codePointAt(0)));
}